// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__2XxQS","homeIcon":"Navbar_homeIcon__2aPst","active":"Navbar_active__1zbNW"};